export default class User
{
	public userid = "";
	public username = "";
	public display_name : string | null = null;
	public email = "";
	public status = 0;
	public isAdmin = false;
	public isSubscribed = false;
	public eduEligibilityOverride = false;
	public trialExpiration : Date | null = null;

	public get uiName()
	{
		return this.display_name || this.username;
	}

	public get trialing() : boolean
	{
		return this.trialExpiration != null && this.trialExpiration.getTime() > Date.now();
	}
}